"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuList, NavigationMenuItem, NavigationMenuLink } from "@/components/ui/navigation-menu";
const services = ["Spine Surgery", "Pain Management", "Rehabilitation Services", "Pre- and Post-Operative Care", "Consultations for Spinal Conditions"];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const filteredMenuItems = React.useMemo(() => {
    if (!menuItems) return [];
    let seenHowItWorks = false;
    return menuItems.filter(item => {
      if (item.label === "How It Works") {
        if (seenHowItWorks) return false;
        seenHowItWorks = true;
      }
      return true;
    });
  }, [menuItems]);
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i} className="h-5 w-3/4 bg-muted animate-pulse rounded" />)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    const fallbackLinks = [{
      label: "HSE Reimbursement Guide",
      href: "#"
    }, {
      label: "Required Documentation",
      href: "#"
    }, {
      label: "Travel & Accommodation",
      href: "#"
    }, {
      label: "FAQ",
      href: "#"
    }];
    return <ul className="space-y-3">
        {fallbackLinks.map((link, i) => <li key={i} data-index={i}>
            <Link to={link.href} className="text-[#ffffff] hover:text-[#65d19d] transition-colors text-sm">
              {link.label}
            </Link>
          </li>)}
      </ul>;
  }
  return <NavigationMenu viewport={false} className="flex justify-start w-full max-w-none">
      <NavigationMenuList className="flex-col items-start space-y-3 gap-0">
        {filteredMenuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild className="hover:bg-transparent focus:bg-transparent p-0 bg-transparent">
              <Link to={item.href || "#"} className="text-[#ffffff] hover:text-[#65d19d] transition-colors text-sm">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function ClinicAgatasInformation() {
  return <section id="clinic-agatas-information" className="bg-[#264256] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">

          <div className="flex flex-col items-start">
            <Link to="#" className="inline-block mb-6">
              <img src="https://charming-joey.10web.cloud/wp-content/uploads/2026/05/Agatas-logo_vertikalus.-spalvotas-sviesus.png" alt="Clinic Agatas Logo" className="w-auto !h-[230px]" />
            </Link>
            <div className="flex gap-3">
              {[{
              icon: Facebook,
              href: "https://www.facebook.com/clinicagatas",
              label: "Facebook"
            }, {
              icon: Instagram,
              href: "https://www.instagram.com/clinicagatas/",
              label: "Instagram"
            }, {
              icon: Linkedin,
              href: "https://www.linkedin.com/company/clinic-agatas/",
              label: "LinkedIn"
            }].map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} data-index={i} className="w-10 h-10 rounded-full bg-[#65d19d] text-[#264256] flex items-center justify-center hover:bg-[#65d19d]/90 transition-colors" aria-label={social.label}>
                    <Icon className="w-5 h-5" />
                  </Link>;
            })}
            </div>
          </div>

          <div>
            <h4 className="font-default font-semibold text-[#65d19d] mb-4 text-lg">Services</h4>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="#" className="text-[#ffffff] hover:text-[#65d19d] transition-colors text-sm">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div>
            <h4 className="font-default font-semibold text-[#65d19d] mb-4 text-lg">Navigation</h4>
            <MenuProvider menu_id="38">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div>
            <h4 className="font-default font-semibold text-[#65d19d] mb-4 text-lg">Contact Details</h4>
            <div className="space-y-6">
              <div>
                <h5 className="font-default font-medium text-[#ffffff] text-sm mb-2">Kaunas Clinic</h5>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2 text-sm text-[#ffffff]">
                    <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#65d19d]" />
                    <span>Linkuvos g. 60, Kaunas, Lithuania</span>
                  </li>
                  <li className="flex items-center gap-2 text-sm text-[#ffffff]">
                    <Phone className="w-4 h-4 shrink-0 text-[#65d19d]" />
                    <span>+370 602 26118</span>
                  </li>
                  <li className="flex items-center gap-2 text-sm text-[#ffffff]">
                    <Mail className="w-4 h-4 shrink-0 text-[#65d19d]" />
                    <span>info@clinicagatas.com</span>
                  </li>
                </ul>
              </div>
              <div>
                <h5 className="font-default font-medium text-[#ffffff] text-sm mb-2">Irish Coordinator</h5>
                <ul className="space-y-2">
                  <li className="flex items-center gap-2 text-sm text-[#ffffff]">
                    <Phone className="w-4 h-4 shrink-0 text-[#65d19d]" />
                    <span>+353 00000</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>

        <Separator className="bg-[#a9e5c9]/20" />

        <div className="mt-8 text-center">
          <p className="text-sm text-[#a9e5c9]">
            © {new Date().getFullYear()} Clinic Agatas. All rights reserved.
          </p>
        </div>
      </div>
    </section>;
}